"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const Fonts = (props) => {
  const _a = props, { className, size = IconSize.Medium, color = "inherit" } = _a, rest = __objRest(_a, ["className", "size", "color"]);
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    __spreadValues({ width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass }, rest),
    /* @__PURE__ */ React.createElement("path", { d: "M6.002 5.76L1 18.83h2.724l1.15-3.15h4.895l1.171 3.15h2.767L8.705 5.76H6.002zm1.32 3.279l1.596 4.342H5.725l1.597-4.342zM23 18.83v-6.066c0-2.278-1.469-3.662-4.002-3.662-2.17 0-3.725 1.32-4.001 3.044h2.512c.212-.553.66-.894 1.404-.894 1.064 0 1.554.66 1.554 1.469v.702c-.383-.276-1.34-.553-2.171-.553-2.065 0-3.682 1.234-3.682 3.044 0 1.98 1.617 3.086 3.533 3.086 1.043 0 2-.362 2.32-.681v.51H23zm-2.533-2.597c-.234.51-.958.83-1.724.83-.83 0-1.681-.34-1.681-1.17 0-.81.85-1.171 1.681-1.171.766 0 1.49.319 1.724.83v.68z" })
  );
};
export default Fonts;
